import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const getHeaders = () => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

export const uploadDaysEntriesService = {
  getRecordsRange: async (startDate, endDate) => {
    const url = `${domain}/api/UploadDaysEntries/range?start=${startDate}&end=${endDate}`;
    return await axios.get(url, { headers: getHeaders() });
  },

  bulkUpload: async (payload) => {
    const url = `${domain}/api/UploadDaysEntries/bulk`;
    return await axios.post(url, payload, { headers: getHeaders() });
  },

  getEmployeeMasterlist: async () => {
    const url = `${domain}/api/Employee/masterlist`;
    return await axios.get(url, { headers: getHeaders() });
  },

  // ADDED: Template Generation Logic
  downloadTemplate: async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Upload Template");

    // 1. Define Headers
    const headers = ["Employee Number", "Days Worked", "Date Start", "Date End"];
    const headerRow = worksheet.addRow(headers);

    // 2. Style Headers (Green background, white bold text)
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "2E7D32" },
      };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // 3. Set Column Widths
    worksheet.columns = [
      { width: 20 }, // Employee Number
      { width: 15 }, // Days Worked
      { width: 15 }, // Date Start
      { width: 15 }, // Date End
    ];

    // 4. Add Example Row (Optional but helpful)
    const exampleRow = worksheet.addRow(["EMP-001", 6.3, "2024-06-11", "2024-06-20"]);
    exampleRow.eachCell((cell) => {
      cell.font = { italic: true, color: { argb: "757575" } };
    });

    // 5. Generate and Save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "Days_Worked_Upload_Template.xlsx");
  }
};